import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../../api';
import toast from 'react-hot-toast';

export default function RegisterPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '', organization: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.register(form);
      toast.success('Account created! Please sign in.');
      navigate('/organizer/login');
    } catch (e) {
      toast.error(e.response?.data?.error || 'Registration failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#1A2744,#2D3A5F)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 20, padding: 40, maxWidth: 460, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="https://omogusiiwarriors.org/icons/logo.png" alt="OWW" style={{ width: 70, height: 70, objectFit: 'contain', marginBottom: 12 }} />
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, color: '#1A2744', margin: '0 0 4px' }}>Create Organizer Account</h1>
        </div>
        <form onSubmit={handleSubmit}>
          {[
            { label: 'Full Name *', key: 'name', placeholder: 'Your full name' },
            { label: 'Email *', key: 'email', placeholder: 'your@email.com', type: 'email' },
            { label: 'Phone *', key: 'phone', placeholder: '0712345678' },
            { label: 'Organization', key: 'organization', placeholder: 'Company or club name (optional)' },
            { label: 'Password *', key: 'password', placeholder: '••••••••', type: 'password' },
          ].map(f => (
            <div key={f.key} style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>{f.label}</label>
              <input type={f.type || 'text'} placeholder={f.placeholder} value={form[f.key]}
                onChange={e => setForm({...form, [f.key]: e.target.value})}
                style={{ width: '100%', padding: '11px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                required={f.label.includes('*')} />
            </div>
          ))}
          <button type="submit" disabled={loading}
            style={{ width: '100%', background: '#E8521A', color: '#fff', padding: 14, borderRadius: 10, border: 'none', fontWeight: 700, fontSize: 16, cursor: loading ? 'not-allowed' : 'pointer', marginTop: 8, opacity: loading ? 0.7 : 1 }}>
            {loading ? '⏳ Creating account...' : 'Create Account'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 14, color: '#6B7280' }}>
          Already have an account? <Link to="/organizer/login" style={{ color: '#E8521A', fontWeight: 600 }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
